"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    card: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: colors_1.default.BLUE,
        margin: 5,
        padding: 20,
        minWidth: 200,
        minHeight: 100,
    },
});
exports.default = styles;
